<template>
  <vx-card
    class="mb-base"
    :title="$t('class-overview.course-outline-unit-title')"
    title-color="primary"
  >
    <div>
      <ul class="vx-timeline">
        <li v-for="(unit, index) in courseOutlineUnits" :key="index">
          <template v-if="unit.vdoSetUnit">
            <div
              :class="getTimelineBackground(unit)"
              class="timeline-icon"
            >
              <feather-icon
                v-if="checkIsLearningDone(unit)"
                icon="CheckIcon"
                svgClasses="text-white stroke-current w-5 h-5"
              />
              <feather-icon
                v-else-if="checkIsStillLearning(unit)" icon="PlayIcon"
                svgClasses="text-white stroke-current w-5 h-5"
              />
              <feather-icon
                v-else icon="ClockIcon"
                svgClasses="text-white stroke-current w-5 h-5"
              />
            </div>
            <div class="timeline-info">

              <div class="flex flex-row justify-between">
                <p class="font-semibold text-l text-primary">
                  {{$t('class-overview.unit-no')}} {{ unit.seq }}
                </p>
                <p v-if="unit.studentUnitLearn && unit.studentUnitLearn.courseOutlineUnit.countLearnPercent"
                   class="font-semibold text-l text-primary">
                  {{ getLearnPercent(unit) }}%
                </p>
                <p v-else class="font-semibold text-l text-primary">
                  {{ $t('class-overview.not-count-percent') }}
                </p>
              </div>
              <p class="font-semibold text-xl pb-4 ">
                {{ unit.nameLocal }}
              </p>

              <!-- AGENDA OBJECTIVE REFERENCE EXPECT-->
              <!--            <div class="flex justify-between">
                            &lt;!&ndash;  EXPECT&ndash;&gt;
                            <vs-chip
                              :class="{ '_highlight': (unitsData[index])
                                            && unitsData[index].isUnitDetailOpen
                                            && unitsData[index].unitDetailCurrentButton === 0 }"
                              class="unit-detail-button cursor-pointer"
                              color="primary"
                              transparent
                              @click.native="setUnitDetail(index, 0, unit.descriptionLocal || 'ไม่มีเนื้อหาโดยย่อ')"
                            >
                              {{ $T('class-overview.unit-expect') }}
                            </vs-chip>
                            &lt;!&ndash;  OBJECTIVE&ndash;&gt;
                            <vs-chip
                              :class="{ '_highlight': (unitsData[index])
                                            && unitsData[index].isUnitDetailOpen
                                            && unitsData[index].unitDetailCurrentButton === 1 }"
                              class="unit-detail-button cursor-pointer"
                              color="primary"
                              transparent
                              @click.native="setUnitDetail(index, 1, unit.unitObjective || 'ไม่มีข้อมูล')"
                            >
                              {{ $T('class-overview.unit-objective') }}
                            </vs-chip>
                            &lt;!&ndash;  AGENDA&ndash;&gt;
                            <vs-chip
                              :class="{ '_highlight': (unitsData[index])
                                            && unitsData[index].isUnitDetailOpen
                                            && unitsData[index].unitDetailCurrentButton === 2 ? true : false }"
                              class="unit-detail-button cursor-pointer"
                              color="primary"
                              transparent
                              @click.native="setUnitDetail(index, 2, unit.unitAgenda || 'ไม่มีข้อมูล')"
                            >
                              {{ $T('class-overview.unit-agenda') }}
                            </vs-chip>
                            &lt;!&ndash;  REFERENCE&ndash;&gt;
                            <vs-chip
                              :class="{ '_highlight': (unitsData[index])
                                            && unitsData[index].isUnitDetailOpen
                                            && unitsData[index].unitDetailCurrentButton === 3 }"
                              class="unit-detail-button cursor-pointer"
                              color="primary"
                              transparent
                              @click.native="setUnitDetail(index, 3, unit.unitReference || 'ไม่มีข้อมูล')"
                            >
                              {{ $T('class-overview.unit-reference') }}
                            </vs-chip>
                          </div>-->
            </div>

            <div class="flex flex-row justify-between px-0 pb-4 pr-4 mt-4">
              <!-- PRE TEST-->
              <p class="text-center">
              <span class="block flex flex-row">
                <feather-icon class="cursor-pointer" icon="FileTextIcon"
                              svgClasses="text-darkgrey stroke-current h-4 w-4"/>
                <span class="ml-2 font-semibold">Pretest</span>
              </span>
                <span class="text-2xl font-semibold block">
                {{ getStudentPreTestScore(unit) }}
              </span>
                <span>
                <small class="text-grey activity-e-time">
                {{ getMaxPreTestScore(unit) }}
                </small>
              </span>
              </p>
              <!--  VIDEO TIME-->
              <p class="text-center">
              <span class="block flex flex-row">
                <feather-icon class="cursor-pointer" icon="FilmIcon"
                              svgClasses="text-darkgrey stroke-current h-4 w-4"/>
                <span class="ml-2 font-semibold">E-Class</span>
              </span>
                <span class="text-2xl font-semibold block">
                {{getTotalUnitLearnTime(unit)}}
              </span>
                <span>
                <small class="text-grey activity-e-time">
                  {{ getTotalUnitVdoTime(unit)}}
                </small>
              </span>
              </p>
              <!-- POST TEST-->
              <p class="text-center">
              <span class="block flex flex-row">
                <feather-icon class="cursor-pointer" icon="FileTextIcon"
                              svgClasses="text-darkgrey stroke-current h-4 w-4"/>
                <span class="ml-2 font-semibold">Posttest</span>
              </span>
                <span class="text-2xl font-semibold block">
                {{ getStudentPostTestScore(unit) }}
              </span>
                <span>
                <small class="text-grey activity-e-time">
                {{ getMaxPostTestScore(unit) }}
                </small>
              </span>
              </p>
            </div>
            <!-- ACTION BUTTON-->
            <vs-button
              class="mr-2 shadow-lg card-button"
              color="#7367F0" gradient-color-secondary="#CE9FFC" type="gradient"
              @click="routeToVirtualClass"
            >
              <span>{{ $t('home.start-learn') }}</span>
            </vs-button>
            <vs-divider/>
          </template>
        </li>
      </ul>
    </div>
  </vx-card>
</template>

<script>
import {formatSecondToHHMMSS} from "@/utils/format";

export default {
  name: "CourseOutlineUnitInfo",
  props: [
    'courseOutlineUnits',
    'studentEnrollDetail',
  ],
  methods:{
    routeToVirtualClass() {
      this.$router.push(`/e-learning/virtual-class/${this.studentEnrollDetail.id}`);
    },
    getTimelineBackground(unit){
      let style = 'bg-grey';
      if(this.checkIsLearningDone(unit)){
        style = 'bg-success';
      }else if(this.checkIsStillLearning(unit)){
        style = 'bg-primary';
      }
      return style;
    },
    checkIsLearningDone(unit){
      let percent = this.getLearnPercent(unit);
      return percent === 100;

    },
    checkIsStillLearning(unit){
      let percent = this.getLearnPercent(unit);
      return percent > 0 && percent < 100;
    },
    getLearnPercent(unit) {
      let percent = 0;
      if(unit.studentUnitLearn){
        percent = unit.studentUnitLearn.learnPercent
      }
      return percent;
    },
    getTotalUnitLearnTime(unit) {
      let totalUnitLearnTime = '00:00:00';
      if(unit.studentUnitLearn && unit.studentUnitLearn.totalLearnTime){
        totalUnitLearnTime = unit.studentUnitLearn.totalLearnTime;
        if(totalUnitLearnTime > unit.vdoSetUnit.totalVdoLength){
          totalUnitLearnTime = unit.vdoSetUnit.totalVdoLength
        }
        totalUnitLearnTime = formatSecondToHHMMSS(totalUnitLearnTime);
      }
      return totalUnitLearnTime;
    },
    getTotalUnitVdoTime(unit){
      let totalUnitVdoTime = '00:00:00';
      if(unit.vdoSetUnit && unit.vdoSetUnit.totalVdoLength){
        totalUnitVdoTime = formatSecondToHHMMSS(unit.vdoSetUnit.totalVdoLength);
      }
      return totalUnitVdoTime;
    },
    getMaxPreTestScore(unit){
      let score = 0;
      if(unit.preTestExpectScore && unit.preTestExpectScore){
        score = unit.preTestExpectScore;
      }
      return score;
    },
    getStudentPreTestScore(unit){
      let score = 0;
      if(unit.studentUnitTest && unit.studentUnitTest.pretestScore){
        score = unit.studentUnitTest.pretestScore;
      }
      return score;
    },
    getMaxPostTestScore(unit){
      let score = 0;
      if(unit.postTestExpectScore && unit.postTestExpectScore){
        score = unit.postTestExpectScore;
      }
      return score;
    },
    getStudentPostTestScore(unit){
      let score = 0;
      if(unit.studentUnitTest && unit.studentUnitTest.posttestScore){
        score = unit.studentUnitTest.posttestScore;
      }
      return score;
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";

.vs-card__actions {
  position: absolute;
  right: 24px;
}

.unit-detail {
  transition: all ease-in 300ms;
  height: 0px !important;
  opacity: 0;

  &._show {
    height: 80px !important;
    opacity: 1;
  }
}

.unit-detail-button {
  transition: all ease-in 300ms;

  &._highlight {
    background: rgba(var(--vs-primary), 1);
    color: white;
  }
}

</style>
